import React from 'react';
import { Box, Typography, Container, Grid, Link, IconButton, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { LogoIcon } from '../../tool';
import { useInstitutions } from '../../../hooks/useInstitutions';

const LandingFooter = () => {
  const { institutions } = useInstitutions();
  const institution = institutions && institutions.length > 0 ? institutions[0] : null;

  return (
    <Box sx={{ bgcolor: '#001a13', color: 'rgba(255,255,255,0.7)', pt: 10, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              {institution?.logo ? (
                <Box
                  component="img"
                  src={institution.logo}
                  alt="Logo"
                  sx={{ width: 40, height: 40, mr: 2, objectFit: 'contain' }}
                />
              ) : (
                <LogoIcon sx={{ fontSize: 40, mr: 2, color: 'white' }} />
              )}
              <Typography variant="h6" sx={{ color: 'white', fontWeight: 900, letterSpacing: 1 }}>
                {institution?.name || "AGUA POTABLE"}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 4, lineHeight: 1.8 }}>
              Liderando la innovación en la gestión de recursos hídricos para una comunidad más fuerte y sostenible.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {institution?.facebookUrl && (
                <SocialIcon icon={<FacebookIcon />} url={institution.facebookUrl} />
              )}
              {institution?.whatsApp && (
                <SocialIcon icon={<WhatsAppIcon />} url={`https://wa.me/${institution.whatsApp.replace(/[^0-9]/g, '')}`} />
              )}
            </Box>
          </Grid>

          <Grid >
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 800, mb: 3 }}>Institución</Typography>
            <FooterLink text="Historia" />
            <FooterLink text="Directorio" />
            <FooterLink text="Estatutos" />
            <FooterLink text="Transparencia" />
          </Grid>

          <Grid >
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 800, mb: 3 }}>Servicios</Typography>
            <FooterLink text="Pagos en línea" />
            <FooterLink text="Reportar Fuga" />
            <FooterLink text="Consultas" />
            <FooterLink text="Mantenimiento" />
          </Grid>

          <Grid >
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 800, mb: 3 }}>Contacto</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>{institution?.direction || 'Av. Principal S/N, Comunidad Agua Potable'}</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>Teléfono: {institution?.telephone || '(591) 4XXXXXX'}</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>Email: {institution?.email || 'contacto@aguapotable.org'}</Typography>
            {institution?.businessHours && (
               <Typography variant="body2" sx={{ mb: 2, color: 'primary.light' }}>⏰ {institution.businessHours}</Typography>
            )}
          </Grid>
        </Grid>

        <Divider sx={{ my: 6, borderColor: 'rgba(255,255,255,0.05)' }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="caption">
            © 2026 AGUA POTABLE - Potable e Innovación. Todos los derechos reservados.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.75rem' }}>Terminos</Link>
            <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.75rem' }}>Privacidad</Link>
            <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.75rem' }}>Cookies</Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const SocialIcon = ({ icon, url }) => (
  <IconButton
    component="a"
    href={url || "#"}
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      color: 'rgba(255,255,255,0.5)',
      bgcolor: 'rgba(255,255,255,0.05)',
      '&:hover': { color: 'white', bgcolor: 'primary.main', transform: 'translateY(-3px)' },
      transition: 'all 0.3s'
    }}
  >
    {icon}
  </IconButton>
);

const FooterLink = ({ text }) => (
  <Link
    display="block"
    href="#"
    color="inherit"
    underline="none"
    sx={{ mb: 1.5, fontSize: '0.9rem', '&:hover': { color: 'primary.main', pl: 1 }, transition: 'all 0.2s' }}
  >
    {text}
  </Link>
);

export default LandingFooter;
